export default __webpack_public_path__ + "static/media/fb.7c9ce35b.svg";